/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { defineModule } from 'direct-vuex'
import { moduleGetterContext, moduleActionContext } from '../index'
import * as Lib from '@/lib/functions/plain'
// import * as types from '@/lib/definition/types'
import moment from "moment-timezone"
moment.locale('ja')

const KEY_LOGINUSER = 'LOGINUSER'
export interface MastersState {
  emojiList: any[]
  mastersUpdated: boolean|null
  [key: string]: any;
}

const Masters = defineModule({
  state: (): MastersState => {
    return {
      emojiList: [],
      mastersUpdated: null
    }
  },
  getters: {
    isLoggedIn: (...args): boolean => {
      const { state } = loginGetterContext(args)
      return state.accessToken !== null
    },
  },
  mutations: {
    SET_VALUE (state, param: { name: string; value: any }) {
      state[param.name] = param.value
    },
    SET_ACCESS_TOKEN (state, token: string) {
      state.accessToken = token
      state.errorMessage = null
      Lib.Session.login(token)
    },
    LOGOUT (state) {
      state.accessToken = null
      state.username = null
      state.displayName = null
      state.currentRoles = []
      Lib.Session.remove(KEY_LOGINUSER)
      Lib.Session.logout()
    }
  },
  actions: {
    async getMasters(context) {
      const { commit, rootState } = moduleActionContext(context, Masters)
      const retval = await Lib.Ajax.getHandleError<any>('/api/slackevent/getemojilist', "Failed to get emoji", {}, rootState.Login.accessToken)
      var emojis: any|null = retval.data.data
      if (emojis == null) {
        emojis = []
      }
      emojis.filter((element: any) => element.custom)
      emojis.forEach((element: any) => {
        element.short_names = [element.id]
        element.keywords = [element.id]
      });
      commit.SET_VALUE({name: 'emojiList', value: emojis})
      commit.SET_VALUE({name: 'mastersUpdated', value: true})
      return emojis
    },
    async getMastersIfNeeded(context){
      const { state, dispatch } = moduleActionContext(context, Masters)
      if (state.mastersUpdated == null) {
        await dispatch.getMasters()
      }
    }
  },
  namespaced: true
})

export default Masters
const loginGetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, Masters)




